import usePrivateAxios from "@/common/api/usePrivateAxios"
import { Mapper } from "@/common/services/mapper";
import { useQuery } from "@tanstack/react-query";

type UseCompanyNotificationsConfigurationsAvailableNotificationsProps<T> = {
  filters?: {
    companyId?: string;
  }
  mapper?: (data: any) => T,
}

export const useCompanyNotificationsConfigurationsAvailableNotifications = <T,>({
  filters: { companyId } = {},
  mapper = Mapper.default<T>(),
}: UseCompanyNotificationsConfigurationsAvailableNotificationsProps<T>) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['clientCompanyNotificationConfigurationsAvailableNotifications', companyId],
    queryFn: () => privateAxios.get(`/client/company_notification_configurations/available_notifications`, {
      params: {
        'company_id': companyId,
      },
    }),
    select: (data) => mapper(data?.data?.data),
  });
}
